import * as React from 'react';
import styled from 'styled-components';

import { Selector } from '@longline/aqua-ui/inputs/Selector';

interface IProps {
  value?: number;
  /** Fired when control value changes. */
  onChange?: (value: number) => void;
}

// Values are ORGANIX's solver codes (CODAquaSolver.h):
const SolverControl = (props: IProps) =>
  <Wrapper>
    <Selector name="0" dark type='circle' label="Standard Euler" checked={props.value == 0} onChange={() => props.onChange?.(0)}/>
    <Selector name="1" dark type='circle' label="Forward Euler" checked={props.value == 1} onChange={() => props.onChange?.(1)}/>
    <Selector name="3" dark type='circle' label="Runge-Kutta 4" checked={props.value == 3} onChange={() => props.onChange?.(3)}/>
  </Wrapper>

const Wrapper = styled.div`
  padding: 8px 0 8px 24px;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 4px;
  width: 100%;
`

export { SolverControl }
